import React from 'react';
import style from './style/Loader.module.scss';

export const Loader: React.FC<LoaderProps> = ({
    loaderColor = "#325ec3",
    loaderSize = 75,
    relative
}) => (
    <div className={`${style.wrapper} ${relative ? style.relative : ''}`}>
        <div className={`${style.loaderWrapper}`}>
            <div className={style.loaderAnimationWrapper} style={{ width: loaderSize, height: loaderSize }}>
                <svg viewBox="22 22 44 44">
                    <circle
                        cx="44"
                        cy="44"
                        r="20.2"
                        fill="none"
                        strokeWidth="3.6"
                        stroke={loaderColor}
                    />
                </svg>
            </div>
        </div>
    </div>
);

export interface LoaderProps {
    /**
     * The color of the loader circle
     * @default "#325ec3"
     */
    loaderColor?: string;

    /**
     * The size of the loader circle.
     * If using a number, the pixel unit is assumed. If using a string, you need to provide the CSS unit, e.g '3rem'
     * @default "75"
     */
    loaderSize?: string|number;

    /**
     * Toggle relative positioning
     */
    relative?: boolean;
}

export default Loader;
